import { Directive, effect, ElementRef, inject, input } from '@angular/core';
import { makeTranslateService } from 'src/data/services/common/translate/translate-service-factory';

@Directive({
  selector: '[appTranslateText]',
})
export class TranslateTextDirective {
  text = input<string | undefined | null>(null, {
    alias: 'appTranslateText',
  });
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
  private translateService = makeTranslateService();

  constructor() {
    effect(() => {
      const text = this.text();

      if (!this.elementRef || !this.elementRef.nativeElement) return;

      if (text) {
        this.elementRef.nativeElement.textContent =
          this.translateService.translateText(text);
      } else {
        this.elementRef.nativeElement.textContent = '';
      }
    });
  }
}
